/** Tiny 1×1 PNG (red) as data URL for offer image e2e. */
export const E2E_TINY_PNG =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z8BQDwAEhQGAhKmMIQAAAABJRU5ErkJggg==';

export const E2E_MOCK_EMAIL = 'e2e@spara.is';
export const E2E_MOCK_PASSWORD = 'e2e-password';
export const E2E_MOCK_ACCESS_TOKEN = 'e2e-admin-mock-token';

export const MOCK_COMPANY_ID = 1001;
export const MOCK_CATEGORY_PARENT_ID = 10;
export const MOCK_CATEGORY_CHILD_ID = 11;
export const MOCK_GROUP_A_ID = 50;
export const MOCK_GROUP_B_ID = 51;
export const MOCK_NOTIFY_OFFER_ID = 5001;
export const MOCK_INACTIVE_OFFER_ID = 5002;

export const mockCompany = {
    id: MOCK_COMPANY_ID,
    name: 'E2E Prufufyrirtæki',
    logo: null,
    kennitala: '0101307789',
    status: 1,
};

export const mockCategories = [
    {
        id: MOCK_CATEGORY_PARENT_ID,
        parent_id: 0,
        name: 'Matur',
        name_en: 'Food',
        logo: null,
        order: 1,
    },
    {
        id: MOCK_CATEGORY_CHILD_ID,
        parent_id: MOCK_CATEGORY_PARENT_ID,
        name: 'Veitingastaðir',
        name_en: 'Restaurants',
        icon: null,
        order: 1,
    },
];

/** Special distribution rows + real groups (expand=group). */
export const mockSpecialCompanies = [
    {
        id: 1,
        name: 'Sparakjör',
        type: 'lykilkjor',
        has_membership_card: false,
        group: { id: 1, name: 'Dreifing', order: 1 },
    },
    {
        id: 3,
        name: 'B2B',
        type: 'b2b',
        has_membership_card: false,
        group: { id: 1, name: 'Dreifing', order: 1 },
    },
    {
        id: MOCK_GROUP_A_ID,
        name: 'E2E Markhópur',
        type: 'group',
        has_membership_card: false,
        group: { id: 2, name: 'Aðrir', order: 2 },
    },
    {
        id: MOCK_GROUP_B_ID,
        name: 'E2E Annar hópur',
        type: 'group',
        has_membership_card: false,
        group: { id: 2, name: 'Aðrir', order: 2 },
    },
];

export const MOCK_GROUP_TOKEN_COUNTS = {
    [MOCK_GROUP_A_ID]: 40,
    [MOCK_GROUP_B_ID]: 10,
};

function buildSeedOffers() {
    return [
        {
            id: MOCK_NOTIFY_OFFER_ID,
            title: 'E2E Tilkynningar tilboð',
            title_en: 'E2E Notify Offer',
            description: 'Tilboð til að prófa greidda push-sendingu',
            discount: '20%',
            image: E2E_TINY_PNG,
            torgid_company_id: MOCK_COMPANY_ID,
            torgid_company: mockCompany,
            approved: true,
            is_active: true,
            notified: false,
            group_ids: `${MOCK_GROUP_A_ID},${MOCK_GROUP_B_ID}`,
            created_at: new Date().toISOString(),
        },
        {
            id: MOCK_INACTIVE_OFFER_ID,
            title: 'E2E Óvirkt tilboð',
            title_en: 'E2E Inactive Offer',
            description: 'Tilboð sem er ekki í birtingu',
            discount: '10%',
            image: E2E_TINY_PNG,
            torgid_company_id: MOCK_COMPANY_ID,
            torgid_company: mockCompany,
            approved: false,
            is_active: false,
            notified: false,
            group_ids: String(MOCK_GROUP_A_ID),
            created_at: new Date().toISOString(),
        },
    ];
}

/**
 * Shape expected by parseUserData / loginUser (results.user is an array of company_user rows).
 */
export function buildMockLoginResults() {
    return {
        access_token: E2E_MOCK_ACCESS_TOKEN,
        token_type: 'Bearer',
        roles: ['company_user'],
        permission: [
            { name: 'cu_dashboard-view' },
            { name: 'cu_offer-view' },
            { name: 'cu_offer-create' },
            { name: 'cu_offer-update' },
            { name: 'offer-notify' },
        ],
        user: [
            {
                id: 9001,
                torgid_user_id: 9001,
                torgid_company_id: MOCK_COMPANY_ID,
                torgid_special_company_id: null,
                torgid_company: mockCompany,
                torgid_special_company: null,
                name: 'E2E Notandi',
                email: E2E_MOCK_EMAIL,
                phone: '8212345',
                torgid_user: {
                    id: 9001,
                    name: 'E2E Notandi',
                    email: E2E_MOCK_EMAIL,
                    phone: '8212345',
                    profile_picture: null,
                },
            },
        ],
    };
}

/** In-memory offers created during a mock session (seeded for notification e2e). */
export let mockCreatedOffers = buildSeedOffers();

export function resetMockCreatedOffers() {
    mockCreatedOffers = buildSeedOffers();
}

export function addMockCreatedOffer(payload) {
    const id = 5100 + mockCreatedOffers.length + 1;
    const row = {
        id,
        title: payload.title || 'Untitled',
        title_en: payload.title_en || '',
        description: payload.description || '',
        discount: payload.discount || '',
        image: payload.image || E2E_TINY_PNG,
        torgid_company_id: payload.torgid_company_id || MOCK_COMPANY_ID,
        torgid_company: mockCompany,
        approved: !!payload.approved,
        is_active: payload.is_active !== false,
        notified: !!payload.notified,
        group_ids: payload.group_ids || null,
        created_at: new Date().toISOString(),
    };
    mockCreatedOffers.push(row);
    return row;
}
